import { useTranslation } from 'react-i18next';
import { Box } from '@radix-ui/themes';

import { ActionButton, ButtonGroup } from './StyledComponents';
import TextField from '../../shared/TextField';
import useEmailForm from './hooks/useEmailForm';
import SectionCard from '../../shared/SectionCard/SectionCard.jsx';

export default function ChangeEmail({ pendingEmail }) {
  const {
    handleChange,
    handleSubmit,
    values,
    disabledSubmit,
    inputError,
    handleBlur,
    dirty,
  } = useEmailForm();
  const { t } = useTranslation('accountSettings');

  return (
    <SectionCard title={t('emailForm.title')}>
      <Box mt="2" pb="4">
        <TextField
          value={values.email}
          onChange={handleChange}
          error={dirty && inputError('email') ? inputError('email') : ''}
          onBlur={handleBlur}
          warning={
            pendingEmail && !inputError('email')
              ? t('emailForm.pendingEmailWarning')
              : ''
          }
          name="email"
          label={t('emailForm.emailLabel')}
        />
        <ButtonGroup
          lastInputHasMessage={!!pendingEmail || !!inputError('email')}
        >
          <ActionButton
            type="submit"
            variant="containedBlue"
            onClick={handleSubmit}
            disabled={disabledSubmit}
          >
            {t('emailForm.submit')}
          </ActionButton>
        </ButtonGroup>
      </Box>
    </SectionCard>
  );
}
